/* SPIRITS — en-tête fixe, compte à rebours, menu mobile, retour en haut.
   Ce fichier peut être chargé plusieurs fois : chaque élément n'est
   initialisé qu'une seule fois. */
(function () {
  'use strict';

  function deuxChiffres(n) { return n < 10 ? '0' + n : '' + n; }

  /* ---------- compte à rebours ---------- */
  function compteARebours() {
    var cibles = document.querySelectorAll('[data-fin]:not([data-compte-pret])');
    if (!cibles.length) return;

    cibles.forEach(function (el) {
      el.setAttribute('data-compte-pret', '1');
      var fin = new Date(el.getAttribute('data-fin')).getTime();
      if (isNaN(fin)) return;

      function tic() {
        var reste = fin - Date.now();

        if (reste <= 0) {
          var apres = el.getAttribute('data-apres');
          el.textContent = apres || 'Offre terminée';
          el.classList.add('termine');
          return;
        }

        var j = Math.floor(reste / 86400000);
        var h = Math.floor((reste % 86400000) / 3600000);
        var m = Math.floor((reste % 3600000) / 60000);
        var s = Math.floor((reste % 60000) / 1000);

        var etroit = window.innerWidth < 560;
        el.textContent = (j > 0 ? j + ' j ' : '') + deuxChiffres(h) + ' h ' +
                         deuxChiffres(m) + ' min' + (etroit ? '' : ' ' + deuxChiffres(s) + ' s');
        setTimeout(tic, 1000);
      }
      tic();
    });
  }

  /* ---------- menu mobile ---------- */
  function menu() {
    document.querySelectorAll('.burger').forEach(function (burger) {
      if (burger.dataset.spiritsPret === '1') return;
      burger.dataset.spiritsPret = '1';

      var cible = burger.getAttribute('aria-controls');
      var drawer = cible ? document.getElementById(cible) : null;
      if (!drawer) {
        var entete = burger.closest('.header');
        drawer = entete ? entete.querySelector('.drawer') : null;
      }
      if (!drawer) return;

      function basculer(ouvrir) {
        burger.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
        drawer.classList.toggle('is-open', ouvrir);
      }

      burger.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        basculer(burger.getAttribute('aria-expanded') !== 'true');
      });
      drawer.querySelectorAll('a').forEach(function (a) {
        a.addEventListener('click', function () { basculer(false); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') basculer(false);
      });
    });
  }

  /* ---------- retour en haut ---------- */
  function retourHaut() {
    var b = document.querySelector('.haut-de-page');
    if (!b || b.dataset.spiritsPret === '1') return;
    b.dataset.spiritsPret = '1';

    b.addEventListener('click', function () {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
    window.addEventListener('scroll', function () {
      b.classList.toggle('visible', window.scrollY > 700);
    }, { passive: true });
  }

  /* ---------- apparition au défilement ---------- */
  function apparition() {
    var blocs = document.querySelectorAll('.reveal:not([data-spirits-vu])');
    if (!blocs.length) return;

    var reduit = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduit || !('IntersectionObserver' in window)) {
      blocs.forEach(function (el) { el.dataset.spiritsVu = '1'; el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entrees) {
      entrees.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -6% 0px', threshold: 0.03 });
    blocs.forEach(function (el) { el.dataset.spiritsVu = '1'; io.observe(el); });
  }

  function init() { menu(); compteARebours(); retourHaut(); apparition(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }

  document.addEventListener('shopify:section:load', init);
})();
